  import { MenuItems } from "./MenuItems";

  export const adminMenuItems: MenuItems[] = [
    {
      label: "Dashboard",
      path: "/admin",
      icon: "pi pi-home",
    },
    {
      label: "Users",
      path: "/admin/users",
      icon: "pi pi-users",
    },
    {
      label: "Customers",
      path: "/admin/customers",
      icon: "pi pi-users",
    },
    {
      label: "Transactions history",
      path: "/admin/transaction-history",
      icon: "pi pi-history",
    },
    {
      label: "Transactions log",
      path: "/admin/transaction-log",
      icon: "pi pi-list",
    },
    {
      label: "Payment Link",
      path: "/admin/payment-link",
      icon: "pi pi-link",
    },
    {
      label: "Withdrawals",
      path: "/admin/manage-withdrawals",
      icon: "pi pi-credit-card",
    },
    {
      label: "Documents Type",
      path: "/admin/manage-document",
      icon: "pi pi-file",
    },
    {
      label: "Manage Partners",
      path: "/admin/partners",
      icon: "pi pi-cog",
    },
    {
      label: "Monetary zones",
      path: "/admin/manage-monetary-zone",
      icon: "pi pi-money-bill",
    },
    {
      label: "Countries",
      path: "/admin/countries-monetary-zone",
      icon: "pi pi-globe",
    },
    {
      label: "Services",
      path: "/admin/manage-service",
      icon: "pi pi-list",
    },
    {
      label: "User Roles",
      path: "/admin/manage-roles",
      icon: "pi pi-wrench",
    },
    {
      label: "Ip Address",
      path: "/admin/manage-ip-address",
      icon: "pi pi-share-alt",
    },
    {
      label: "Maintenance Mode",
      path: "/admin/maintenance",
      icon: "pi pi-wrench",
    },
  ];
